import * as environment from '../../../config/environment';

import { BaseAPI } from "../../BaseAPI";

class TahsilatRaporAPI extends BaseAPI {

    constructor() {
        const baseUrl = environment.API_URL + "Rapor/GetTahsilatRapor";
        super(baseUrl);
    }
    geExportPdfListe(sicilKodu: number, tahsilatTarihi: Date, vezneKodu: number, seriNo: string, makbuzNo: number) {

        var request = new TahsilatRaporRequest(sicilKodu, tahsilatTarihi, vezneKodu, seriNo, makbuzNo);
        return this.post("", request, false);
    }

}
export default new TahsilatRaporAPI();
class TahsilatRaporRequest {
    public sicilKodu: number;
    public tahsilatTarihi: Date;
    public vezneKodu: number;
    public seriNo: string;
    public makbuzNo: number;

    constructor(sicilKodu: number, tahsilatTarihi: Date, vezneKodu: number, seriNo: string, makbuzNo: number) {

        this.tahsilatTarihi = tahsilatTarihi;
        this.sicilKodu = sicilKodu;
        this.vezneKodu = vezneKodu;
        this.seriNo = seriNo;
        this.makbuzNo = makbuzNo;

    }
}
export { TahsilatRaporRequest };